<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-document-checked"></i> 宝宝列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <!--<el-button-->
          <!--type="primary"-->
          <!--icon="el-icon-delete"-->
          <!--class="handle-del mr10"-->
          <!--@click="handleAdd"-->
        <!--&gt;新增</el-button>-->
        <!-- <el-input v-model="query.name" placeholder="宝宝名或者宝宝id" class="handle-input mr10"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button> -->
      </div>
      <el-table :data="tableData" border stripe class="table" header-cell-class-name="table-header">
        <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column label="生日">
          <template slot-scope="scope">
            {{scope.row.birth_time | format()}}
          </template>
        </el-table-column>
        <el-table-column label="怀孕周期">
          <template slot-scope="scope">
            {{typeof scope.row.gestationalDays !== 'undefined' ? scope.row.gestationalDays + '天' : '未记录'}}
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            {{typeof scope.row.sex !== 'undefined' ? (scope.row.sex === 0 ? '男' : '女') : '未记录'}}
          </template>
          </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="viewDetail(scope.row)">查看记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="Baby.pageIndex"
          :page-size="Baby.limit"
          :total="Baby.total"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增护士弹出框 -->
    <el-dialog title="添加护士账号" :visible.sync="addVisible" width="30%">
      <el-form ref="addForm" :model="addForm" label-width="70px">
        <el-form-item label="姓名">
          <el-input v-model="addForm.name" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="addForm.mobile" maxlength="11"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  export default {
    computed: {
      ...mapState(["LoginInfo", "Baby"])
    },
    data() {
      return {
        authVisible: false,
        addVisible: false,
        addForm: {},
        authForm: {},
        query: {
          address: "",
          name: "",
          pageIndex: 1,
          limit: 10
        },
        tableData: [],
        multipleSelection: [],
        delList: [],
        idx: -1,
        id: -1
      };
    },
    watch: {
      "Baby.list"(val) {
        this.tableData = val
      },
      "LoginInfo.account" (val) {
        this.getData()
      }
    },
    created() {
      this.setBabyOffset()
      this.getData()
    },
    methods: {
      ...mapActions([
        "setBabyOffset",
      ]),
      // 获取 easy-mock 的模拟数据
      getData() {
        const account = this.LoginInfo.account
        console.log(account)
        if (!account || (!account.id && !account.admin)) {
          return false
        }
        const Baby = this.Baby;
        this.$api.getBabyList(account.id || 0, {
          offset: Baby.offset || 0,
          limit: Baby.limit
        });
      },
      viewDetail (row) {
        this.$store.dispatch('setBaby', row)
        sessionStorage.setItem('baby_' + row.id, JSON.stringify(row))
        this.$router.push({
          path: "/baby/" + row.id,
          title: `${row.name}记录`
        });
      },
      // 触发搜索按钮
      handleSearch() {
        this.$set(this.query, "pageIndex", 1);
        this.getData();
      },
      // 添加
      handleAdd() {
        this.addVisible = true;
      },
      // 保存编辑
      async saveAdd() {
        this.addVisible = false;
        const addForm = this.addForm;
        let res = await this.$api.createBaby(addForm);
        const data = res.data
        if (data.ok) {
          this.getData()
          this.$message.success(`【${addForm.mobile}】账号开通成功`);
        }
      },
      // 分页导航
      handlePageChange(index) {
        this.setBabyOffset({
          offset: (index - 1) * 10
        })
        this.getData();
      }
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 300px;
    display: inline-block;
  }
  .table {
    width: 100%;
    font-size: 14px;
  }
  .red {
    color: #ff0000;
  }
  .mr10 {
    margin-right: 10px;
  }
  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Baby.vue